<template lang="pug">
    v-card(style="-max-width:calc(100% - 10px); border: 0px solid red;" elevation="0")
        v-tabs(ref="tabThemeList" show-arrows style="border-bottom:0px solid lightgrey")
            v-tabs-slider(color="black" style="position:absolute; bottom:0")
            v-tab(@click="getTheme('0', 'investmentCompaniesPath')")
                div
                    v-icon(style="fill:red; border:0px solid;") $investmentCompanies
                    div(class="home-tab-item") {{ $t('theme_investment_companies') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('1') : ''")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-currency-usd
                    div(class="home-tab-item") {{ $t('theme_highest_yield') }}
            //- v-tab(@click="getTheme('overMa200Path')")
                div
                    v-icon(style="border:0px solid;") $overMa200
                    div(class="home-tab-item") Over MA200
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('3', 'mostWatchedPath') : ''")
                div
                    v-icon(style="border:0px solid;") $mostWatched
                    div(class="home-tab-item") {{ $t('theme_most_watched') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('4', 'insidersPath') : ''")
                div
                    v-icon(style="border:0px solid;") $insiders
                    div(class="home-tab-item") {{ $t('theme_insiders') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('5') : ''")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-trending-up
                    div(class="home-tab-item") {{ $t('theme_best_mtd') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('8') : ''")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-trending-down
                    div(class="home-tab-item") {{ $t('theme_worst_mtd') }}
            //- v-tab(@click="getTheme('salesGrowthPath')")
                div
                    v-icon(style="border:0px solid;") $salesGrowth
                    div(class="home-tab-item") Sales Growth
            //- v-tab(@click="getTheme('profitMarginPath')")
                div
                    v-icon(style="border:0px solid;") $profitMargin
                    div(class="home-tab-item") Profit Margin
            //- v-tab(@click="getTheme()")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-keyboard-return
                    div(class="home-tab-item") ROE
            //- v-tab(@click="getTheme('epsPath')")
                div
                    v-icon(style="border:0px solid;") $eps
                    div(class="home-tab-item") EPS
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('12') : ''")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-calendar
                    div(class="home-tab-item") {{ $t('theme_upcoming_reports') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('11', 'latestReportsPath') : ''")
                div
                    v-icon(style="border:0px solid;") $latestReports
                    div(class="home-tab-item") {{ $t('theme_latest_reports') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('13') : ''")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-currency-usd-off
                    div(class="home-tab-item") {{ $t('theme_not_profitable') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('14') : ''")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-emoticon-happy
                    div(class="home-tab-item") {{ $t('theme_edgers_top_tips') }}
            v-tab(@click="getCachedStocks.length > 10 ? getTheme('15', 'theCabDriverPath') : ''")
                div
                    v-icon(style="border:0px solid;") $theCabDriver
                    div(class="home-tab-item") {{ $t('theme_the_cab_driver') }}
            //- v-tab(@click="getTheme()")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-domain
                    div(class="home-tab-item") Recent IPO
            //- v-tab(@click="getTheme()")
                div
                    v-icon(style="opacity:0.54; border:0px solid;") mdi-lightbulb-outline
                    div(class="home-tab-item") Suggest a Category
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';

export default {
    name: 'ThemesToolbar',
    data() {
        return {
            oneTimeCheck: true
        };
    },
    computed: {
        ...mapGetters([
            'getStocksOfTheme',
            'getStocksFromArrayOfStocks',
            'getSelectedThemes',
            'getCachedStocks',
            'getPricesWithFrequency',
            'getStockIds'
        ])
    },
    methods: {
        ...mapActions([
            'loadStocksFromArrayOfStocks',
            'loadStocksOfTheme',
            'loadPricesWithFrequency',
            'loadCachedCompaniesAndReports'
        ]),
        ...mapMutations([
            'setLastCheckedTheme',
            'setSelectedThemes',
            'setCachedStocks',
            'setCheckWhenFinishedCaching'
        ]),
        addActiveTab(iconId) {
            const investmentCompaniesPathElement = document.getElementById(iconId);

            investmentCompaniesPathElement.classList.add('fill-active');
        },
        removeActiveTab(element) {
            element.classList.remove('fill-active');
        },
        async loadInDataToCachedStocks(theme_id) {
            this.setLastCheckedTheme(theme_id);

            // console.log(this.getSelectedThemes.find((t) => t.theme_id === theme_id));

            if(this.getSelectedThemes.find((t) => t.theme_id === theme_id) === undefined) {
                this.setCheckWhenFinishedCaching(false);

                await this.loadCachedCompaniesAndReports(theme_id);
                await this.loadStocksOfTheme(theme_id);

                // console.log(JSON.parse(JSON.stringify(this.getStocksOfTheme)));

                const themes = this.getSelectedThemes;
                const ids = this.getStocksOfTheme.map((s) => s.stock_id);

                themes.push({
                    theme_id: theme_id,
                    stock_ids: ids
                });

                // console.log(JSON.parse(JSON.stringify(themes)));

                this.setSelectedThemes(themes);

                const stocksObject = {
                    stocks: ids
                };

                // console.log(JSON.parse(JSON.stringify(stocksObject)));

                await this.loadStocksFromArrayOfStocks(stocksObject);

                // console.log(JSON.parse(JSON.stringify(this.getStocksFromArrayOfStocks)));

                const stocksFromArray = this.getStocksFromArrayOfStocks.map(async (s) => {
                    const testObject = {
                        stock_id: s.stock_id,
                        frequency: 7
                    };

                    await this.loadPricesWithFrequency(testObject);

                    const prices = this.getPricesWithFrequency;

                    if(this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).performancemtd !== undefined) {
                        s.performancemtd = this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).performancemtd;
                    } else if(this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).yield !== undefined) {
                        s.yield = this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).yield;
                    } else if(this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).transaction_date !== undefined) {
                        s.transaction_date = this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).transaction_date;
                    } else if(this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).date_report !== undefined) {
                        s.date_report = this.getStocksOfTheme.find((sot) => sot.stock_id === s.stock_id).date_report;
                    }

                    s.theme_id = theme_id;
                    s.prices = prices;

                    return s;
                });

                // console.log(stocksFromArray);

                const stocksFromArrayOfStockIds = [];

                for(const s of stocksFromArray) {
                    const temp = await s;

                    stocksFromArrayOfStockIds.push(temp);
                }

                // console.log(JSON.parse(JSON.stringify(this.getStockIds)));
                // console.log(JSON.parse(JSON.stringify(stocksFromArrayOfStockIds)));

                const sortedStocksFromArrayOfStockIds = stocksFromArrayOfStockIds.sort((a, b) => this.getStockIds.indexOf(a.stock_id) - this.getStockIds.indexOf(b.stock_id));

                // console.log(JSON.parse(JSON.stringify(sortedStocksFromArrayOfStockIds)));

                const total = this.getCachedStocks.concat(sortedStocksFromArrayOfStockIds);

                // console.log(JSON.parse(JSON.stringify(total)));

                const preTotal = total.filter((t, i) => i < 10);

                // console.log(JSON.parse(JSON.stringify(preTotal)));

                if(this.oneTimeCheck) {
                    this.oneTimeCheck = false;

                    this.setCachedStocks(preTotal);

                    setTimeout(() => {
                        this.setCachedStocks(total);
                    }, 1000);
                } else {
                    this.setCachedStocks(total);
                }

                this.setCheckWhenFinishedCaching(true);

                // console.log(this.getSelectedThemes);
                // console.log(this.getCachedStocks);
            }
        },
        async getTheme(themeId, iconId = 'notset') {
            // console.log(this.$refs.tabThemeList.$el);

            const tabThemeListElement = this.$refs.tabThemeList.$el;

            const allTabs = tabThemeListElement.querySelectorAll('.v-tab div span svg path');

            for(const el of allTabs) {
                this.removeActiveTab(el);
            }

            if(iconId !== 'notset') {
                this.addActiveTab(iconId);
            }

            await this.loadInDataToCachedStocks(themeId);
        }
    },
    async mounted() {
        this.addActiveTab('investmentCompaniesPath');

        await this.loadInDataToCachedStocks('0');
    }
}
</script>

<style scoped>
.theme--light.v-sheet,
>>>.theme--light.v-tabs>.v-tabs-bar {
    background-color: transparent !important;
}

/* here is workaround */
.v-tabs-slider.black {display: none}

>>>.v-tabs-bar {
    height: auto;
}

.v-tabs-bar .v-tab[role='tab'] {
    background-color: #fff;
    border: 1px solid #144B4D;
    border-radius: 4px;
    display: inline-block;
    margin: 0 10px 0 0;
    text-align: left;
    padding: 8px;
    align-items: baseline;
}

.v-tab[role='tab'].v-tab--active {
    background-color: #144B4D;
}

.v-tab[role='tab'] .v-icon {
    font-size: 22px;
}

.v-tab[role='tab'] .v-icon,
.v-tab[role='tab'] span.v-icon {
    height: 22px;
    width: 22px;
}

.v-tabs-bar__content .v-tab[role='tab']:last-child {
    margin-right: 0;
}

.home-tab-item {
    color: #144B4D;
    font-size: 11px;
    text-transform: capitalize;
}

.v-tab--active .home-tab-item,
.v-tab--active .v-icon,
.v-tab--active:hover .v-icon,
.v-tab--active:hover .home-tab-item {
    color: #fff;
}

.v-tab[role='tab']:hover {
    background-color: #f4f4f4;
}

.v-tab--active:hover,
.v-tab[role='tab']:focus {
    background-color: #144B4D !important;
}

.v-tabs-bar__content .v-tabs-slider-wrapper,
.v-tabs .v-tab:before {
    display: none;
}

/*>>> .fill-active {
    fill: #000000;
}*/
>>> .fill-active {
    fill: #fff;
}

.theme--light.v-tabs>.v-tabs-bar,
.v-tab.theme--light.v-tabs>.v-tabs-bar {
    -background-color: transparent;
}

/**/

>>>.v-card {
    margin-left:
}

>>> .v-slide-group__prev,
>>> .v-slide-group__next {
    min-width: 16px;
    flex: auto;
}

>>> .v-slide-group__prev {
    padding-right: 12px;
}

>>> .v-slide-group__next {
    padding-left: 12px;
}

>>>.v-slide-group__prev i,
>>>.v-slide-group__next i {
    font-size: 30px;
    width: 16px;
}

>>>.v-slide-group__prev--disabled,
>>>.v-slide-group__next--disabled {
    opacity: .3;
}


>>> .v-tab:hover div div,
>>> .v-tab:hover div i {
    -color: black;
}

>>> .v-tab:hover div span svg path {
    -fill: black;
}

.v-tab--active {
    -color: black;
}

.v-tabs-slider {
    height: 1px;
}
</style>
